<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <v-data-table-server
      vmodel:items-per-page="perPage"
      :headers="headers"
      :items="maestroTarjetas"
      :items-per-page="perPage"
      v-model:page="page"
      :loading="loading"
      :item-value="id"
      :items-length="totalMaestroTarjetas"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="maestroTarjetasStore.search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            @input="loadMaestroTarjetas"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="newItem()"
            >Nuevo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.porcentaje_comision`]="{ item }">
        {{ parseFloat(item.porcentaje_comision).toFixed(2) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" color="green">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)" color="red">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table-server>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useMaestroTarjetasStore } from '@/stores/maestroTarjetasStore'
import { userIsRecepcion } from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'

const maestroTarjetasStore = useMaestroTarjetasStore()

const { maestroTarjetas, totalMaestroTarjetas, page, perPage } =
  storeToRefs(maestroTarjetasStore)

const emit = defineEmits(['edit', 'delete', 'newItem'])

const headers = ref([
  { title: 'Tarjeta', key: 'nombre', align: 'center' },
  { title: 'Porcentaje Comisión', key: 'porcentaje_comision', align: 'center' },
  {
    title: '  ',
    width: '100px',
    key: 'actions',
    sortable: false
  }
])

onMounted(async () => {
  await loadMaestroTarjetas()
})

const loadMaestroTarjetas = async () => {
  await maestroTarjetasStore.fetchMaestroTarjetas({})
}

const onPageChange = (newPage) => {
  maestroTarjetasStore.setPage(newPage)
  maestroTarjetasStore()
}

const onItemsPerPageChange = (newItemsPerPage) => {
  perPage.value = newItemsPerPage
  maestroTarjetasStore.setRows(newItemsPerPage)
  loadMaestroTarjetas()
}

const deleteItem = (item) => {
  emit('delete', item.id)
}

const editItem = (item) => {
  emit('editItem', item)
}

const newItem = () => {
  emit('newItem')
}
</script>
